module.exports = __webpack_public_path__ + "static/media/IMG_2144y.95288988.jpg";